/**
 * Generated by orval v6.19.1 🍺
 * Do not edit manually.
 * BBO Accounting Location Api
 * Accounting Location API defining how to get and modify Accounting Locations

REST APIs for Back Office stock count service. This service is specifically designed for stock functionality- stock count. Feature services are.<ul><li>Get Stock Count Type List</li></ul>

REST APIs for Back Office Forex Management Service. This service is specifically designed for forex functionality- forex counting, variance declaration, forex details, and etc. Feature services are.<ul><li>Branch Forex Overview</li><li>Fetch the Forex currencies</li></ul>

Provide Task Status and Uncompleted Task History
 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  BboPouchManagementBadRequestResponse,
  BboPouchManagementFailureResponseResponse,
  BboPouchManagementForbiddenResponse,
  GetPouchListFiltersParams,
  GetPouchListFiltersResponseResponse,
  UnauthorizedResponse,
} from '../model';
import { customInstance } from '../mutator/customInstance';
import type { ErrorType } from '../mutator/customInstance';

/**
 * Pouch list filters
 * @summary Get All filters for pouch list
 */
export const getPouchListFilters = (params?: GetPouchListFiltersParams, signal?: AbortSignal) => {
  return customInstance<GetPouchListFiltersResponseResponse>({
    url: `/bm-pouch-management/v1/pouch/list/filters`,
    method: 'get',
    params,
    signal,
  });
};

export const getGetPouchListFiltersQueryKey = (params?: GetPouchListFiltersParams) => {
  return [`/bm-pouch-management/v1/pouch/list/filters`, ...(params ? [params] : [])] as const;
};

export const getGetPouchListFiltersQueryOptions = <
  TData = Awaited<ReturnType<typeof getPouchListFilters>>,
  TError = ErrorType<
    | BboPouchManagementBadRequestResponse
    | UnauthorizedResponse
    | BboPouchManagementForbiddenResponse
    | BboPouchManagementFailureResponseResponse
  >,
>(
  params?: GetPouchListFiltersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPouchListFilters>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPouchListFiltersQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPouchListFilters>>> = ({ signal }) =>
    getPouchListFilters(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPouchListFilters>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPouchListFiltersQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPouchListFilters>>
>;
export type GetPouchListFiltersQueryError = ErrorType<
  | BboPouchManagementBadRequestResponse
  | UnauthorizedResponse
  | BboPouchManagementForbiddenResponse
  | BboPouchManagementFailureResponseResponse
>;

/**
 * @summary Get All filters for pouch list
 */
export const useGetPouchListFilters = <
  TData = Awaited<ReturnType<typeof getPouchListFilters>>,
  TError = ErrorType<
    | BboPouchManagementBadRequestResponse
    | UnauthorizedResponse
    | BboPouchManagementForbiddenResponse
    | BboPouchManagementFailureResponseResponse
  >,
>(
  params?: GetPouchListFiltersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPouchListFilters>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetPouchListFiltersQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};
